<template>
  <div>
    <!-- list view -->
    <div id="list_view2" v-cloak  class="container-fluid fade-in main-content-margin-top flex-grow-1">
      <div v-if="paginator.pageItems.length==0" class="row">
        <div class="col">
          <span v-if="!activeSearch" class="text-muted">Enter search values above</span>
          <span v-else class="text-muted">No SMS results found</span>
        </div>
      </div>
      <div v-show="paginator.pageItems.length>0" class="row justify-content-around">
        <!-- main content -->
        <div class="col-8 d-print-none">
          <!-- campaign table container -->
          <div class="row">
            <div id="table_container_sms" class="col campaign-table-container">
              <table id="tableAppSMS" class="table table-hover table-striped table-sm campaign-table">
                <thead class="sortable-header">
                  <tr>
                    <th id="hdr_group_name" data-field="sent_dt" data-type="date" @click="sortRecords($event.target)" 
                      class="pb-2 text-nowrap col-a"
                      :class="[(sort.column=='sent_dt') ? sortClass : '', showLocalTimeStamp ? 'col-ts' : '']">
                      Sent
                    </th>
                    <th id="hdr_launch_date" data-field="sender_mobile_code" data-type="text" @click="sortRecords($event.target)" 
                      class="pb-2 text-nowrap col-b"
                      v-bind:class="(sort.column=='sender_mobile_code') ? sortClass : '' ">
                      Short Code
                    </th>
                    <th id="hdr_launch_date" data-field="message" data-type="text" @click="sortRecords($event.target)" 
                    class="pb-2 text-nowrap col-c"
                    v-bind:class="(sort.column=='message') ? sortClass : '' ">
                      Message
                    </th>
                    <th id="hdr_campaign_name" 
                      class="pb-2 text-nowrap col-d nosort">
                      Campaign Info
                    </th>
                    <th v-if="showSmsEvents" id="hdr_activity" data-field="events.activity" data-type="boolean" class="pb-2 text-nowrap col-de">
                      Activity
                    </th>
                    <th class="nosort pb-2 col-e" >&nbsp;</th>
                  </tr>
                </thead>
                <tbody>

                  <template v-for="(item,idx) in paginator.pageItems">
                    <tr tabindex="0"
                      @click.prevent="setSelectedRecord(item)" 
                      @dblclick.stop="showDetail(item)"
                      v-on:keyup.enter="showDetail(item)"
                      v-on:keydown.down.prevent="selectNextCampaign(idx)"
                      v-on:keydown.up.prevent="selectPreviousCampaign(idx)"
                      :class="{'bg-info': selectedRecord && selectedRecord.uuid == item.uuid}">
                      <td class="col-a" :class="{'col-ts':showLocalTimeStamp}">
                        {{ (item.sent_dt) ? formatDate(item.sent_dt, showLocalTimeStamp) : ''}}
                      </td>
                      <td class="col-b">{{ item.sender_mobile_code }}</td>
                      <td class="col-c text-nowrap d-none d-md-table-cell">
                        <span class="d-inline-block text-truncate align-bottom" style="font-size: .9em; max-width: calc(100vw * .55 - 500px);">{{ item.message }}</span>
                      </td>
                      <td class="col-d d-none d-md-table-cell">
                        <span v-if="item.campaign.purpose" data-toggle="tooltip"  
                          :data-original-title="'<b>Type:</b> ' + item.campaign.purpose" 
                          class="small campaign-info-icon d-inline-block text-white mr-md-1 mb-1 mb-lg-0">
                          {{ (item.campaign.purpose)? item.campaign.purpose.substr(0,1) : '' }}
                        </span>
                        <span v-if="item.campaign.marketing_program" data-field="programType"
                          data="text"
                          class="small campaign-info text-white d-inline-block text-white mr-md-1 mb-1 mb-lg-0"
                          >{{item.campaign.marketing_program}}</span>
                        <span v-if="item.campaign.marketing_strategy" data-field="marketingStrategy"
                          data="text"
                          class="small campaign-info text-white d-inline-block text-white mr-md-1 mb-1 mb-lg-0"
                          >{{item.campaign.marketing_strategy}}</span>
                      </td>
                      <td v-if="showSmsEvents">
                        <span v-if="item.has_event_data && Object.keys(item.events).length > 0" data-toggle="popover" :data-content="formatSmsEventSummary(item.events)" data-title="Activity" class="d-inline-block" style="min-width: 30px;">
                          <span v-if="item.events.c" class="engagement-item d-inline-block mr-1 bg-primary"></span>
                          <span v-if="item.events.sub" class="engagement-item d-inline-block mr-1 bg-success"></span>
                          <span v-if="item.events.unsub" class="engagement-item d-inline-block mr-1 bg-danger"></span>
                        </span>
                      </td>

                      <td class="text-right col-e">
                        <a v-if="false" class="glyphicons-a mr-1" @click.prevent="showDetail(item)" data-toggle="tooltip" title="View details">
                          <span class="glyphicons glyphicons-zoom-in"></span>
                        </a>
                        <a v-if="false && privs.RE" class="glyphicons-a mr-1" @click.prevent="confirmResend(item)" data-toggle="tooltip" title="Resend message">
                          <span class="glyphicons glyphicons-send"></span>
                        </a>
                        <a href="#" class="glyphicons-a" style="font-size: 1.1em;" data-toggle="dropdown" aria-haspopup="true"><span class="glyphicons glyphicons-more"></span> </a>&nbsp;
                        <div v-if="privs.DF || privs.PE" class="dropdown-menu dropdown-menu-right">
                          <a v-if="privs.PE" class="dropdown-item" @click="printEmail">
                            <span class="glyphicons glyphicons-print mr-1"></span>Print copy of message
                          </a>
                          <a v-if="privs.DR" class="dropdown-item" @click="deleteMessage">
                            <span class="glyphicons glyphicons-bin mr-1"></span>Delete message
                          </a>
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
          <!-- /campaign table container -->
          <!-- paginator container -->
          <div id="paginator" class="container-fluid">
            <div class="row">
              <div class="col-8 bg-white">
                <template v-if="activeSearch && recordsLength > 10">
                  <div style="padding: 10px 0px;">
                    <div class="btn-group dropup mr-1">
                      <input type="text" class="rowsPerPage text-left form-control form-control-sm" data-toggle="dropdown" v-bind:placeholder.stop="paginator.pageSize + ' rows per page'" v-on:keypress.prevent=""/>
                      <ul id="campaignTypeList" class="dropdown-menu">
                        <template v-for="size in paginator.pageSizeOptions">
                          <a href="#" :class="{active: paginator.pageSize==size }" class="dropdown-item" v-on:click.prevent="setPageSize(size)">
                            {{size}} rows</a>
                        </template>
                      </ul>
                    </div>
                    <div class="btn-group">
                      <span class="small">Page <span>{{paginator.pageIndex+1}}</span> of
                        <span>{{paginator.pageCount}}</span>&nbsp;&nbsp;<span class="text-muted">&horbar;&nbsp;&nbsp;{{recordsLength}} total records</span> </span>
                    </div>

                    <div class="btn-group float-right pagination pagination-sm">
                      <button v-if="paginator.pageIndex > 0" v-on:click="function() {showPage(paginator.pageIndex - 1)}" class="btn btn-sm btn-outline-indigo">
                        Previous
                      </button>
                      <button v-if="paginator.pageIndex + 1 < paginator.pageCount" v-on:click="function() {showPage(paginator.pageIndex + 1)}" class="btn btn-sm btn-outline btn-outline-indigo">
                        Next
                      </button>
                    </div>
                  </div>
                </template>
              </div>
              <div class="col-4">

              </div>
            </div>
          </div>
          <!-- /paginator container -->
          <!-- search information -->
          <template v-if="false && activeSearch">
            <div class="mt-3">
              <span class="form-group font-light text-muted" v-show="emails.length == 0">
                No records found matching '<span class="font-weight-semibold">TODO</span>' between
                {{moment(searchParams.startDate).format("MM/DD/YYYY")}} and
                {{moment(searchParams.endDate).format("MM/DD/YYYY")}}</span>
              <a href="#" @click.prevent="clearSearchResults">
                Clear search<span class="glyphicons glyphicons-remove ml-1"></span>
              </a>
            </div>
          </template>
          <!-- search information -->
        </div>
        <!-- /campaign table container -->

        <!-- preview panel -->
        <div id="sidePanel" class="col-4 d-print-block">
          <div v-show="loadingEmail" id="emptyPreviewPane">
            <div style="line-height: calc(100vh - 100px);text-align: center;">
              <div class="spinner text-gray">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </div>
          <div v-if="selectedRecord && selectedRecord.message">
            <h5>Message Details 
              <small v-if="selectedRecord.campaign_id" class='float-right'><span class="badge bg-secondary text-white">ID: {{campaign.id}}</span></small>
            </h5>
            <div v-if="campaign.name">
              <span class="font-weight-semibold">Campaign Name:</span>
              {{campaign.name}} 
            </div>
            <div>
              <span class="font-weight-semibold">Mobile Number:</span>
              {{selectedRecord.mobile_number}}
            </div>
            <div>
              <span class="font-weight-semibold">Sent on:</span>
              {{formatDate(selectedRecord.sent_dt, false, true)}}
            </div>
            <div>
              <span class="font-weight-semibold">Short Code:</span>
              {{selectedRecord.sender_mobile_code}}
            </div>
            <template v-if="selectedRecord.campaign">
              <div>
                <span class="font-weight-semibold">Purpose:</span>
              {{selectedRecord.campaign.purpose}}
              </div>
              <div>
                <span class="font-weight-semibold">Marketing Program:</span>
                {{selectedRecord.campaign.marketing_program}}
              </div>
              <div>
                <span class="font-weight-semibold">Marketing Strategy:</span>
                {{selectedRecord.campaign.marketing_strategy}}
              </div>
            </template>
            <hr>
            <h5>Message</h5>
              <pre class="message-text">{{selectedRecord.message}}</pre>
            
              <hr>

            <div v-if="showSmsEvents && selectedRecord.events && Object.keys(selectedRecord.events).length">

              <h5>Activity</h5>
              <span class="event-summary" v-html="formatSmsEventSummary(selectedRecord.events)"></span>
            </div>

          </div>
        </div>
        <!-- /preview panel -->

        <!-- /main content -->
      </div>
      <!-- /main content container -->
    </div>
    <!-- end list view-->

  </div>  
</template>
<script>
import moment from 'moment-timezone'
import {mapState} from 'vuex'
import DateFormatting from '@/mixins/date-formatting'
import Email from '@/mixins/email'
import Event from '@/mixins/event'
import Tracking from '@/mixins/tracking'
import CustomFields from '@/mixins/custom-fields'

export default {
  mixins: [DateFormatting,Email,Event,Tracking,CustomFields],
  data: function() {return {
      loadingEmail: false,
      showLocalTimeStamp: false
    }
  },
  computed: {
    ...mapState({
      uiConfig: (state)=>state.user.uiConfig,
      privs: (state)=>state.user.privs,
      emails: (state)=>state.search.emails,
      loading: (state)=>state.ui.loading,
      activeView: (state)=>state.ui.activeView,
      detailView: (state)=>state.ui.detailView,
      activeSubAccount: (state)=>state.ui.activeSubAccount,
      viewType: (state)=>state.ui.viewType,      
      selectedRecord: (state)=>state.search.selectedEmail,
      activeSearch: (state)=>state.search.activeSearch,
      emailsearchParams: (state)=>state.search.searchParams,
      filterEmail: (state)=>state.search.filterEmail,
      paginator: (state)=>state.search.paginator,
      sort: (state)=>state.search.sort,
      showSmsEvents: (state)=>state.user.showSmsEvents,
    }),
    sortClass(){
      return (this.sort.order=='asc') ? 'sort-down': 'sort-up';
    },
    recordsLength: function() {
      return this.emails.length;
    },
    maxPageIndex: function() {
      return Math.ceil(this.emails.length / this.paginator.pageSize);
    },
  }, 
  mounted: function() {
    let that = this;
    
    $('#list_view2').tooltip({selector: '[data-toggle="tooltip"]', html:true, trigger: 'hover', delay: { "show": 500, "hide": 100 }});

    $('#list_view2').popover({
      //find any elements that have something in data-content
      selector: '[data-toggle="popover"]',
      container: 'body',
      delay: { "show": 500, "hide": 100 },
      html: true,
      trigger: 'hover',
      boundary: 'viewport',
    });

    this.showLocalTimeStamp = (this.uiConfig && this.uiConfig.account && this.uiConfig.account.config.show_results_timestamp);

  },
  methods: {
    setPageSize(pageSize) {
      this.$store.commit("setPageSize",pageSize)
    },
    showPage(newPageIndex) {
      this.$store.commit("setPageIndex",newPageIndex);
    },
    setSelectedRecord(email){
      this.$store.commit("setSelectedEmail",email);
    },
    selectNextCampaign(index) {
      if (index < this.paginator.pageItems.length -1) {
        this.setSelectedRecord(this.paginator.pageItems[index+1]);
        $("#tableAppSMS tbody tr")[index+1].focus();
      } else if (this.paginator.pageIndex < this.maxPageIndex-1) {
        this.showPage(this.paginator.pageIndex+1);
        this.$nextTick(()=>{
          this.setSelectedRecord(this.paginator.pageItems[0]);
          $("#tableAppSMS tbody tr")[0].focus();
        });
      }
    },
    selectPreviousCampaign(index) {
      if (index > 0) {
        this.setSelectedRecord(this.paginator.pageItems[index-1]);
        $("#tableAppSMS tbody tr")[index-1].focus();
      } else if (this.paginator.pageIndex > 0) {
        this.showPage(this.paginator.pageIndex-1);
        this.$nextTick(()=>{
          this.setSelectedRecord(this.paginator.pageItems[this.paginator.pageSize-1]);
          $("#tableAppSMS tbody tr")[this.paginator.pageSize-1].focus();            
        });
      }        
    },
    setActiveView(name){
      this.$store.commit("setActiveView",name);
    },
    showDetail(email) {
      // hide any popover that might be displayed
      this.closePopovers();

      this.setSelectedRecord(email);
      this.$store.commit("setResendChange",false);
      this.setActiveView('detail');
    },
    deleteMessage() {
      this.$parent.$refs.searchBar.confirmDelete('selected');
    },
    printEmail() {
      window.print();
      this.trackSubAccountActivity(this.selectedRecord.sub_account_id,"sms_print");
      let props = {
        sub_account_id: this.selectedRecord.sub_account_id,
      }
      this.$store.dispatch("track",{name:"sms_print",props:props})
    },
    sortRecords(colElement){
      const column = $(colElement).data('field');
      var order = 'asc';
      if (this.sort.column == column) {
        order = (this.sort.order == 'asc') ? 'desc' : 'asc' 
      }
      this.$store.dispatch('sortFilteredResults',{column: column,order:order});
    },

  },
  watch: {
    'uiConfig': function(newVal) {
      this.showLocalTimeStamp = (newVal && newVal.account && newVal.account.config.show_results_timestamp);
    }
  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');

.preview-pane {
  border: 0px;
  width: 100%;
  height: calc(100vh - 120px);
  position: fixed;
  overflow-y: auto;
  overflow-x: hidden;
}

#emptyPreviewPane {
}
.col-a {
  min-width: 145px;
  font-size: .9em;
  vertical-align: middle;
}
.col-b {
  min-width: 110px;
}
.col-c {
  min-width: auto;
}
.col-d {
  min-width: 180px;
}
.col-de {
  min-width: 75px;
  max-width: 75px!important;
}
.col-e {
  min-width: 35px;
  max-width: 35px!important;
}
.message-text {
  overflow-x: auto;
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  background-color: var(--gray);
  color: #ffffff;
  padding: .35rem .55rem .5rem .55rem;
  border-radius: 5px;
  font-size: 1rem;
  line-height: 1.3rem;
  font-family: 'Source Sans Pro';
  /*word-wrap: break-word;*/
}

</style>